import { useAppSelector } from '@/Application/Hooks/Redux';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { Link } from '@/modules/perseo-billing/ui/react/src';

export const CancelQR = ({ closeModal }: { closeModal: () => void }) => {
  const { isCencoPayTimeOut } = useAppSelector((state) => state?.billing) || {};
  const { cencoPaySelectOtherPaymentMethodGtm } = useGtmBillingProduct();

  const linkLabel = isCencoPayTimeOut
    ? 'Entendido'
    : 'Elegir otro medio de pago';

  return (
    <Link
      onClick={() => {
        cencoPaySelectOtherPaymentMethodGtm();
        closeModal();
      }}
      className="co-font-semibold"
    >
      {linkLabel}
    </Link>
  );
};
